var map = {
	"./7AugustBreastfeeding_Awareness_camp (1).jpeg": 59758,
	"./7AugustBreastfeeding_Awareness_camp (2).jpeg": 46937,
	"./7AugustBreastfeeding_Awareness_camp (3).jpeg": 59228,
	"./7AugustBreastfeeding_Awareness_camp (4).jpeg": 14700,
	"./Breastfeeding Awareness camp 1.jpeg": 73889,
	"./Breastfeeding Awareness camp 2.jpeg": 2240,
	"./Breastfeeding Awareness camp 3.jpeg": 76951,
	"./Breastfeeding Awareness camp 4.jpeg": 5294,
	"./Breastfeeding Awareness camp 5.jpeg": 27253,
	"./Breastfeeding Awareness camp.jpeg": 94714,
	"./Breastfeeding awareness program at PHC (2).jpeg": 85678,
	"./Breastfeeding awareness program at PHC (3).jpeg": 63211,
	"./Breastfeeding awareness program at PHC (4).jpeg": 28032,
	"./Breastfeeding awareness program at PHC.jpeg": 48467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71454;